export default "__VITE_ASSET__Ccrf53mw__"